export default "__VITE_ASSET__0220eb5d__"